import * as React from "react"
import { cn } from "../../utils/helpers"

export interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
    size?: 'sm' | 'md' | 'lg'
}

const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
}

// Add inline styles for the animation
const spinnerStyle = `
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

const Spinner = React.forwardRef<HTMLDivElement, SpinnerProps>(
    ({ className, size = 'md', ...props }, ref) => {
        const spinnerAnimationStyle = {
            borderColor: 'currentColor',
            borderRightColor: 'transparent',
            borderTopColor: 'transparent',
            animation: 'spin 1s linear infinite',
        };

        return (
            <>
                <style>{spinnerStyle}</style>
                <div
                    ref={ref}
                    className={cn(
                        "inline-block rounded-full border-2 border-solid",
                        sizeClasses[size],
                        className
                    )}
                    style={spinnerAnimationStyle}
                    {...props}
                />
            </>
        );
    }
)
Spinner.displayName = "Spinner"

export { Spinner }
